import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { User, UserResponseData } from "./types/users";
import toast from "react-hot-toast";

// Hook to manage users data
export function useUsers() {
  const queryClient = useQueryClient();
const toastId = "expense-toast";
  // GET all users
  const Users =(params:{ isActive: boolean,delete: boolean, page?:number, size?: number }) => useQuery({
    queryKey: ["users",params],
    queryFn: async ({queryKey}) => {
      try {
        const response = await axios.get(`/api/v1/getActiveInActiveUser`,{
          params:queryKey[1], // Pass params directly here
        });
        return response.data.data as UserResponseData;
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    },
    staleTime: 30000,
  });

  // POST new user
  const addUser = useMutation({
    mutationFn: async (newUser: any) => {
      try {
        const response = await axios.post(`/api/v1/addUser`, newUser);
        return response.data;
      } catch (error) {
        console.error("Error adding user:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["users"]}); // Refresh users data
       toast.success("User has been successfully added.", { id: toastId });
    },
  });

  // GET user by ID
  const getUserById = useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.get(`/api/v1/userById/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching user by ID:", error);
        throw error;
      }
    },
  });

  // UPDATE user
  const updateUser = useMutation({
    mutationFn: async ({ id, updatedUser }: { id: number; updatedUser: any }) => {
      //console.log(updateUser,"pooppo")
      try {
        const response = await axios.put(`/api/v1/userEdit/${id}`, updatedUser);
        return response.data;
      } catch (error) {
        console.error("Error updating user:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["users"]}); // Refresh users data
        toast.success("User has been updated successfully", { id: toastId });
    },
  });
  const GetUserById =(id:string) => useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      try {
        const response = await axios.get(`/api/v1/userById/${id}`);
        return response.data.data as User;
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    },
    staleTime: 30000,
  });
  // DELETE user
  const deleteUser = useMutation({
    mutationFn: async (id: number) => {
      try {
        const response = await axios.put(`/api/v1/tempDeleteUser/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["users"]}); // Refresh users data
        toast.success("User has been successfully deleted.", { id: toastId });
    },
  });

  return { Users,GetUserById,queryClient, addUser, getUserById, updateUser, deleteUser };
}
